<template>
  <form class="add-member-form" @submit.stop.prevent="add">
    <yn-text-field v-model="emailToAdd" :label="'Email'"></yn-text-field>
    <div>
      <yn-button color="primary" :disabled="!isValid">Add</yn-button>
    </div>
  </form>
</template>

<script>
import TextField from '@/components/common/TextField';
import Button from '@/components/common/Button';
export default {
  components: {
    'yn-text-field': TextField,
    'yn-button': Button
  },
  props: {
    role: {
      type: String,
      required: true
    },
    collection: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      emailToAdd: ''
    };
  },
  computed: {
    isValid() {
      const email = this.emailToAdd && this.emailToAdd.trim();
      if (!email || !email.length || !/\S+@\S+\.\S+/.test(email)) {
        return false;
      }

      if (this.collection.map(s => s.toLowerCase()).includes(email.toLowerCase())) {
        return false;
      }

      return true;
    }
  },
  methods: {
    async add() {
      if (!this.isValid) {
        return;
      }

      const lock = this.$lock();
      try {
        const email = this.emailToAdd.trim();
        await this.$store.dispatch(this.role === 'administrator' ? 'topics/addAdministrator' : 'topics/addAnnotator', {
          email,
          id: this.$route.params.id
        });

        this.$toast.success({
          title: 'Update completed',
          message: `'${email}' was added to this topic.`
        });

        this.emailToAdd = '';
      } catch (e) {
        this.$toast.error({
          title: 'Update failed',
          message: `Please, try again later or contact our development team.`
        });
      } finally {
        lock.release();
      }
    }
  }
};
</script>
